import { Component, OnInit, ViewChild, AfterViewInit, AfterViewChecked } from '@angular/core';
import {KbwService} from '../../services/kbwService.service';
import { ExamCompleteModel } from '@src/models/examComplete.model';
import {QuestionWithAnswersModel} from '@src/models/examComplete.model';
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormArray, UntypedFormControl} from '@angular/forms';
import { ExamFinishedModel, QuestionWithAnswer } from '@src/models/examFinished.model';
import { ExamSummary } from '@src/models/examSummary.model';
import { Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from '@src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import Utils from '../../helpers/Utils';

@Component({
    selector: 'app-exam',
    templateUrl: './exam.component.html',
    styleUrls: ['./exam.component.scss'],
    providers: [KbwService],
    standalone: false
})
export class ExamComponent implements OnInit, AfterViewInit, AfterViewChecked {
  questionPerc = 0;
  selectedRadioButtons = [];
  @ViewChild(HeaderComponent)
  private headerComp: HeaderComponent;
  public examForm: UntypedFormGroup;
  public examCode: string;
  public completeExamModel: ExamCompleteModel;
  public examResultModel: ExamFinishedModel;
   public bookType: string;

  get getExamModel(): UntypedFormGroup {
    return this.fb.group({
      questionId : new UntypedFormControl(),
      questionTranslatedText: new UntypedFormControl(),
      answersForQuestion: this.fb.array([]),
      selectedAnswer: new UntypedFormControl()
    });
  }
  get getAnswersForQuestion(): UntypedFormGroup {
    return this.fb.group({
      id : new UntypedFormControl(),
      translatedText : new UntypedFormControl()
    });
  }
  isLoadnig = true;
  isMobile = false;

  constructor(
    private kbwService: KbwService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceDetectorService) {

  }

  ngAfterViewChecked() {
    this.headerComp.isProgressNeeded = true;
    this.headerComp.isHiddenMenu = true;
    this.cdRef.detectChanges();
  }

  ngAfterViewInit() {
    console.log(environment.environmentName);
    console.log(this.bookType);
    if ((environment.environmentName === 'test' && this.bookType !== 'SKFRDriver') && !!sessionStorage.getItem(environment.sessionIsYMUser)) {
      setTimeout(() => 
      {
        this.onSubmit();
      },
      3000);
    }
  }


  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    this. bookType = Utils.getBookType();
    this.completeExamModel = Object.create(null);
    this.examForm = this.fb.group({
      examId : new UntypedFormControl(),
      examCode : new UntypedFormControl(),
      examModel : this.fb.array([])
    });
    this.examForm.valueChanges.subscribe(data => {
      this.completeExamModel = data;
    });

    this.extractData();
  }

  getControls() {
    return (this.examForm.get('controlName') as UntypedFormArray).controls;
  }
  getNestedControls() {
  }
  extractData() {
    this.kbwService.getData<ExamCompleteModel>()
        .subscribe(
          (result) => {
            this.onGetDataSuccess(result);
            this.clearRadioButtons();
        },
        (error) => {
          console.log(error);
        },
        () => { this.isLoadnig = false; });
  }
  private onGetDataSuccess(data: ExamCompleteModel) {
    this.questionPerc = 100 / (data.examModel.length);
    for (let exam = 0; exam < data.examModel.length; exam++) {
      const qaModel = this.examForm.get('examModel') as UntypedFormArray;
      qaModel.push(this.getExamModel);

      for (let answer = 0; answer < data.examModel[exam].answersForQuestion.length; answer++) {
          const answerForQuModel = qaModel.at(exam).get('answersForQuestion') as UntypedFormArray;
          answerForQuModel.push(this.getAnswersForQuestion);
      }
    }
    this.examForm.patchValue(data);
  }

  onChange(ev) {
    if (this.selectedRadioButtons.indexOf(ev.source.name) < 0) {
      this.selectedRadioButtons.push(ev.source.name);
      this.headerComp.progressValue += this.questionPerc;
    }
  }

  public clearRadioButtons() {
    const examControls = this.examForm.get('examModel')['controls'];
    examControls.forEach(element => {
    });
  }

  onSubmit() {
    let eqList: QuestionWithAnswer[] = [];
    // tslint:disable-next-line: max-line-length
    eqList = this.examForm.value.examModel.map((item) => <QuestionWithAnswer> {
      questionId: item.questionId,
      answerId: item.selectedAnswer === null ? 0 : item.selectedAnswer
      });
    if ((environment.environmentName === 'test' && this.bookType !== 'SKFRDriver') && !!sessionStorage.getItem(environment.sessionIsYMUser)) {
        // tslint:disable-next-line: max-line-length
        eqList = [
          {questionId : 1, answerId : 1},
          {questionId: 2, answerId : 4},
          {questionId: 3, answerId: 5},
          {questionId: 4, answerId: 7},
          {questionId: 5, answerId: 9}
        ];
        // console.log(eqList);
    }

    const finishData: ExamFinishedModel = {
      examId: this.examForm.value.examId,
      questionAnswerList: eqList,
      userId: +sessionStorage.getItem('userId'),
      isYMUser: !!sessionStorage.getItem(environment.sessionIsYMUser),
      trainingId: +sessionStorage.getItem(environment.sessionSelectedExam),
      requestId: sessionStorage.getItem(environment.requestIdentifier)
    };
    this.kbwService.sendFinishExamData(finishData).subscribe((res: ExamSummary) => {
      const sum = Object.assign(new ExamSummary(), res);
      if (!!sessionStorage.getItem(environment.sessionIsYMUser)) {
        this.router.navigate(['/summary'], { queryParams: { percentOfCompletion: sum.percentOfCompletion, passed: sum.passed } });
      }
      else {
        sessionStorage.removeItem(environment.sessionLang);
        sessionStorage.removeItem(environment.sessionSelectedExam);
        sessionStorage.removeItem(environment.sessionSelectedTrainingFile);
        this.router.navigate(['/summary'], { queryParams: { percentOfCompletion: sum.percentOfCompletion, passed: sum.passed } });
      }
    });
  }
}
